import { apiClient } from '@lib/api/client';
import type {
  Country,
  Province,
  District,
  Township,
  Neighborhood,
  LocationCode,
  LocationCodeRequest,
} from '../types/geolocation.types';

/**
 * Geolocation Service
 * Handles geolocation-related API calls for address management
 */
export const geolocationService = {
  /**
   * Get list of countries
   */
  async getCountries(): Promise<Country[]> {
    const response = await apiClient.get<Country[]>('/geolocation/countries');
    return response.data;
  },

  /**
   * Get list of provinces (states)
   */
  async getProvinces(): Promise<Province[]> {
    const response = await apiClient.get<Province[]>('/geolocation/provinces');
    return response.data;
  },

  /**
   * Get list of districts by province
   */
  async getDistricts(provinceId: string): Promise<District[]> {
    const response = await apiClient.get<District[]>(
      `/geolocation/districts/${provinceId}`
    );
    return response.data;
  },

  /**
   * Get list of townships (corregimientos) by district
   */
  async getTownships(districtId: string): Promise<Township[]> {
    const response = await apiClient.get<Township[]>(
      `/geolocation/townships/${districtId}`
    );
    return response.data;
  },

  /**
   * Get list of neighborhoods (barrios) by township
   */
  async getNeighborhoods(townshipId: string): Promise<Neighborhood[]> {
    const response = await apiClient.get<Neighborhood[]>(
      `/geolocation/neighborhoods/${townshipId}`
    );
    return response.data;
  },

  /**
   * Get location code for PANAMÁ addresses
   */
  async getLocationCode(data: LocationCodeRequest): Promise<LocationCode | null> {
    const response = await apiClient.post<LocationCode | null>(
      '/geolocation/location-code',
      data
    );
    return response.data;
  },
};
